/* @flow */
import * as actionTypes from './actionTypes';
import {
    getGorgonFormsApi,getGorgonFormQuestionsApi,submitTaskApi,getGorgonTaskApi
} from '../../apiUtils/api';
import type { 
    AddQuestion,MemEmpDetail,
    InputFormData,ApplicationDetail,
    Coverage,ApplicationInfo,
    PhysicianInfo,FormQuestion,
    InputFormQuestion,SubmitPayload,
    Dispatch,EditFormData,ReducerState
} from './flowTypes'
import { transformFormDataToEditMode } from './editFormData'
import { 
    getMemberEmployeeDetail, getApplicantDetail,getApplicationInfo, getPhysicianInfo, getMedicalHistoryQuestions,
    getAdditionalQuestions, getReviewOutcome
} from './submitFormData'

export const getTaskData=(gorgon:ReducerState, jwt:string,taskAcceptedInfoId: string)=>{
    return (dispatch:Dispatch) => getGorgonTaskApi(jwt,taskAcceptedInfoId)
    .then((res)=>res.json()).then((data)=>{
        const error = (data.error:any|null)
        if (error){
            dispatch({type: actionTypes.EDIT_VERIFY_FORM_DATA_ERROR,error: error});
        }else {
            const formData = transformFormDataToEditMode(data,gorgon)
            dispatch({
                type: actionTypes.EDIT_VERIFY_FORM_DATA_SUCCESS, 
                formData: formData,formQuestions: data['form_questions'],
                reviewQuestions: data['review_questions'], formAppCoverages: formData['formAppCoverages'] });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.EDIT_VERIFY_FORM_DATA_ERROR, error: err});
    })
}

export const populateFormsList=(jwt:string,isPROD:boolean)=>{
    return (dispatch:Dispatch) => getGorgonFormsApi(jwt,isPROD).then((res)=>res.json()).then((data) =>{
        const error = (data.error:any|null)
        if (error){
            dispatch({type: actionTypes.REFRESH_GORGON_FORMS_ERROR,error: error});
        }else {
            dispatch({type: actionTypes.REFRESH_GORGON_FORMS_SUCCESS, forms: (data:Array<any>|null) });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.REFRESH_GORGON_FORMS_ERROR, error: err});
    })
}

export const populateFormQuestionsList=(jwt:string,gorgonFormId:number,isPROD:boolean)=>{
    return (dispatch:Dispatch) => getGorgonFormQuestionsApi(jwt,gorgonFormId.toString(),isPROD).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.REFRESH_GORGON_FORM_QUESTIONS_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.REFRESH_GORGON_FORM_QUESTIONS_SUCCESS, formQuestions: (data:Array<any>|null) });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.REFRESH_GORGON_FORM_QUESTIONS_ERROR, error: err});
    })
}

export const docSubmissionCompleted = () => {
    return { type: actionTypes.GORGON_DOC_SUBMITTED_COMPLETED };
}

export const docSubmission = (
    jwt:string,taskAcceptedInfoId:number,formData:InputFormData,
    formQuestions:Array<InputFormQuestion>,formAppCoverages:Array<any>,
    reviewQuestions: Array<any>
    )=>{

    let payload:SubmitPayload = {
        isDocNotLoad: formData.isDocNotLoad?formData.isDocNotLoad:false,
        isDocInvalid: formData.isDocInvalid?formData.isDocInvalid:false,
        isOverrideFormNum: formData.isOverrideFormNum?formData.isOverrideFormNum:false,
        isNoFormNumInDoc: formData.isNoFormNumInDoc?formData.isNoFormNumInDoc:false,
        formNum: formData.formNum,
        taskAcceptedInfoId:taskAcceptedInfoId
    }
    
    if (!formData.isDocNotLoad && !formData.isDocInvalid && !formData.isOverrideFormNum && !formData.isNoFormNumInDoc){
        payload.memberEmployeeDetail=getMemberEmployeeDetail(formData);
        payload.applicantDetail=getApplicantDetail(formData);
        payload.applicationInfo=getApplicationInfo(formData,formAppCoverages);
        payload.physicianInfo=getPhysicianInfo(formData);
        payload.medicalHistoryQuestions=getMedicalHistoryQuestions(formQuestions,formData);
        payload.additionalQuestions=getAdditionalQuestions(formData);
    }
    if (reviewQuestions.length > 0 ){
        payload.reviewOutcome=getReviewOutcome(formData,reviewQuestions)
    }
    
    return (dispatch:Dispatch) => submitTaskApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.GORGON_DOC_SUBMIT_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.GORGON_DOC_SUBMIT_SUCCESS});
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.GORGON_DOC_SUBMIT_ERROR, error: err});
    })
}

export const updateSelectedFormNum=(form:any|null)=>{
    return { type: actionTypes.UPDATE_SELECTED_GORGON_FORM_NUM, form: form}
}

export const clearSelectedFormNum=()=>{
    return { type: actionTypes.CLEAR_SELECTED_GORGON_FORM_NUM };
}

export const addFormExpandablePanel=(panel:any|null)=> {
    return { type: actionTypes.GORGON_FORM_PANEL_EXPANDABLE_ADD, panel: panel}
}

export const removeFormExpandablePanel=(panel:any|null)=> {
    return { type: actionTypes.GORGON_FORM_PANEL_EXPANDABLE_REMOVE, panel: panel}
}

export const updateFormError=(error:any|null)=>{
    return { type: actionTypes.UPDATE_GORGON_FORM_ERROR, formError: error }
}

export const addAppCoverageLine=()=>{
    return { type: actionTypes.ADD_GORGON_FORM_APP_COVERAGE_LINE }
}

export const removeAppCoverageLine=(formId:number)=>{
    return { type: actionTypes.REMOVE_GORGON_FORM_APP_COVERAGE_LINE, formId: formId }
}


// WEBPACK FOOTER //
// ./src/redux/gorgon/actions.js